<template>
  <transition name="progress-bar">
    <div class="progress-bar" :class="{ stick: isSticky }">
      <div
        class="progress-bar__anchor"
        :class="{ active: nowSection === 'about' }"
      >
        <span />基本資訊
      </div>
      <div
        class="progress-bar__anchor"
        :class="{ active: nowSection === 'preview' }"
      >
        <span />實品
      </div>
      <div
        class="progress-bar__anchor"
        :class="{ active: nowSection === 'sample' }"
      >
        <span />內文試閱
      </div>
      <div
        class="progress-bar__anchor"
        :class="{ active: nowSection === 'info' }"
      >
        <span />販售情報
      </div>
      <div
        class="progress-bar__anchor"
        :class="{ active: nowSection === 'special' }"
      >
        <span />特別企劃
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    nowSection: {
      type: String,
      default: "",
    },
    isSticky: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto");

.progress-bar {
  position: fixed;
  top: 50%;
  left: 5vw;
  transform: translate(0, -50%);
  z-index: 400;
  &-enter-active {
    transition: all 3s ease;
  }
  &-leave-active {
    transition: all 1s;
  }
  &-enter,
  &-leave-to {
    transform: translate(-300px, -50%);
    // opacity: 0;
  }

  &__anchor {
    height: 28px;
    font-family: Roboto;
    font-weight: 900;
    color: #000000;
    display: none;
    @media (min-width: 768px) {
      display: flex;
      align-items: center;
      font-size: 20px;
      line-height: 24px;
    }
    @media (min-width: 1200px) {
      font-size: 24px;
      line-height: 28px;
    }
    span {
      display: block;
      background: #fff;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      margin-right: 28px;
      z-index: 50;
      @media (min-width: 1200px) {
        margin-right: 46px;
        width: 48px;
        height: 48px;
      }
    }
  }
  div + div {
    padding-top: 10vh;
    position: relative;
    &:before {
      content: "";
      display: inline-block;
      height: 12vh;
      width: 3px;
      background: #fff;
      position: absolute;
      bottom: 28px;
      left: 14px;
      transform: translate(-50%, 0);
      @media (min-width: 1200px) {
        width: 5px;
        left: 24px;
      }
    }
  }

  .active {
    span {
      background: url(../assets/active.svg);
      border-radius: 0;
      background-size: contain;
      width: 72px;
      height: 72px;
      transform: translate(-21px, 0);
      margin: 0;
      @media (min-width: 1200px) {
        width: 118px;
        height: 120px;
        transform: translate(-34.5px, 0);
      }
    }
  }
}

.stick {
  position: absolute;
  left: 5vw;
  // bottom: -webkit(50px);
  top: 100%;
  transform: translateY(-150%);
}
</style>
